export default __webpack_public_path__ + "static/media/sun.7e00aeda.svg";